import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { getAccountTypes } from '@/api/account';
import { getListHoldersIdRequest } from '@/api/operation';
import { getPEPQuestions } from '@/api/pep';

import { RequiredDocumentSection } from '@/types/document';
import { FetchedFinancialInfo } from '@/types/finance';
import { User } from '@/types/user';

export const setUserData = createAction<{
  user: User;
  requiredSections: RequiredDocumentSection[];
}>('user-data/set-user');

export const resetUserData = createAction('user-data/reset-user');

export const setFinancialInfo = createAction<FetchedFinancialInfo[]>(
  'user-data/set-financial-info',
);

export const fetchAccountTypes = createAsyncThunk(
  'user-data/fetch-account-types',
  () => getAccountTypes(),
);

export const fetchUserHolders = createAsyncThunk(
  'user-data/fetch-user-holders',
  (operationId: string) => getListHoldersIdRequest(operationId),
);

export const fetchPEPQuestions = createAsyncThunk(
  'user-data/fetch-pep-questions',
  () => getPEPQuestions(),
);
